<template>
  <v-app>
    <router-view />
    <network-status />
  </v-app>
</template>

<script>
import NetworkStatus from '@/components/NetworkStatus'

export default {
  name: 'App',
  components: {
    NetworkStatus
  }
}
</script>
